import router from "src/routes/routes";
import CommonAPIService from "./commonHandler";

const api = new CommonAPIService(router);
const API_URL = "/api/caregiverCompliance";

export const caregiverComplianceService = {
  // Get all compliance docs for a caregiver, organized by tier
  getByCaregiver(caregiverId) {
    return api.getCall(`${API_URL}/caregiver/${caregiverId}`);
  },

  // Get full compliance profile (status lights, training hours, breakdown)
  getComplianceProfile(caregiverId) {
    return api.getCall(`${API_URL}/caregiver/${caregiverId}/profile`);
  },

  // Upload a compliance document (with OCR)
  upload(caregiverId, formData) {
    return api.postFormDataCall(`${API_URL}/caregiver/${caregiverId}/upload`, formData);
  },

  // Approve a pending document
  approve(docId, expirationDate) {
    return api.putCall(`${API_URL}/${docId}/approve`, { expiration_date: expirationDate });
  },

  // Reject a pending document
  reject(docId, rejectionNotes) {
    return api.putCall(`${API_URL}/${docId}/reject`, { rejection_notes: rejectionNotes });
  },

  // Grant a waiver (with optional file upload)
  grantWaiver(docId, formData) {
    return api.postFormDataCall(`${API_URL}/${docId}/waiver`, formData);
  },

  // Update a compliance document
  update(docId, data) {
    return api.putCall(`${API_URL}/${docId}`, data);
  },

  // Delete a compliance document
  destroy(docId) {
    return api.deleteCall(`${API_URL}/${docId}`);
  },

  // Get training history (archived periods)
  getTrainingHistory(caregiverId) {
    return api.getCall(`${API_URL}/caregiver/${caregiverId}/training-history`);
  },

  // Get ABI-certified caregivers
  getAbiCertifiedCaregivers() {
    return api.getCall(`${API_URL}/abi-certified-caregivers`);
  },

  // Check clock-in compliance
  checkClockIn(caregiverId, clientId) {
    const url = clientId
      ? `${API_URL}/check-clock-in/${caregiverId}/${clientId}`
      : `${API_URL}/check-clock-in/${caregiverId}`;
    return api.getCall(url);
  },

  // Import ADP compliance data (preview or commit)
  importAdpCompliance(items, preview = false) {
    return api.postCall(`${API_URL}/import-adp`, { items, preview });
  },

  // Get all pending approvals (admin)
  getPendingApprovals() {
    return api.getCall(`${API_URL}/pending-approvals`);
  },

  // Get dashboard summary (pending, expired, expiring soon counts)
  getDashboardSummary() {
    return api.getCall(`${API_URL}/dashboard-summary`);
  },

  // View document file inline (opens in browser)
  viewDocument(docId) {
    return api.getBlobCall(`${API_URL}/${docId}/view`);
  },

  // View waiver file inline (opens in browser)
  viewWaiver(docId) {
    return api.getBlobCall(`${API_URL}/${docId}/view-waiver`);
  },

  // Download document file
  downloadDocument(docId) {
    return api.getBlobCall(`${API_URL}/${docId}/download`);
  },

  // Download waiver file
  downloadWaiver(docId) {
    return api.getBlobCall(`${API_URL}/${docId}/download-waiver`);
  },
};
